import { render } from "./TagBoxList.vue?vue&type=template&id=5fb71cb8&scoped=true"
import script from "./TagBoxList.vue?vue&type=script&lang=js"
export * from "./TagBoxList.vue?vue&type=script&lang=js"

import "./TagBoxList.vue?vue&type=style&index=0&id=5fb71cb8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb71cb8"]])

export default __exports__